import { __assign, __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-7c872eb0"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = ["onClick"];
var _hoisted_4 = { class: "product-title" };
var _hoisted_5 = /*#__PURE__*/ _createTextVNode("待支付");
var _hoisted_6 = /*#__PURE__*/ _createTextVNode("待签字");
var _hoisted_7 = /*#__PURE__*/ _createTextVNode("待绑定信息");
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("待出检测报告");
var _hoisted_9 = /*#__PURE__*/ _createTextVNode("已完成");
var _hoisted_10 = /*#__PURE__*/ _createTextVNode("申请退款");
var _hoisted_11 = /*#__PURE__*/ _createTextVNode("退款完成");
var _hoisted_12 = /*#__PURE__*/ _createTextVNode("订单取消");
var _hoisted_13 = /*#__PURE__*/ _createTextVNode("套餐价格");
var _hoisted_14 = /*#__PURE__*/ _createTextVNode("受检姓名");
var _hoisted_15 = /*#__PURE__*/ _createTextVNode("样本编号");
var _hoisted_16 = /*#__PURE__*/ _createTextVNode("下单时间");
var _hoisted_17 = { style: { textAlign: 'right' } };
var _hoisted_18 = /*#__PURE__*/ _createTextVNode("立即支付");
var _hoisted_19 = /*#__PURE__*/ _createTextVNode("去签字");
var _hoisted_20 = /*#__PURE__*/ _createTextVNode("绑定信息");
var _hoisted_21 = /*#__PURE__*/ _createTextVNode("预览报告");
var _hoisted_22 = { class: "overlay-wrapper" };
var _hoisted_23 = /*#__PURE__*/ _createTextVNode("支付结果查询中...");
var _hoisted_24 = { class: "overlay-wrapper" };
import { ref } from "vue";
import { requestOrderList, payOrder, checkPaymentResult, signName } from "@/api";
import { debounce } from "@/utils";
import router from "@/router";
import ReviewReport from "@/components/reviewReport.vue";
import { Toast } from "vant";
import Esign from "@/components/esign.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MyOrders',
    setup: function (__props) {
        var _this = this;
        var loading = ref(false);
        var finished = ref(false);
        var productsList = ref([]);
        var pageParams = {
            pageIndex: 0,
            pageSize: 10,
        };
        var onLoad = function () {
            debounceGetOrdersList();
        };
        var viewDetails = function (orderId, orderStatus, hasBind) {
            if (orderStatus === 1 || !hasBind) {
                return;
            }
            router.push("/order-details?orderId=" + orderId);
        };
        var getOrdersList = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loading.value = true;
                        pageParams.pageIndex++;
                        return [4 /*yield*/, requestOrderList(pageParams.pageIndex)
                                .catch(function () {
                                finished.value = true;
                                loading.value = false;
                                Toast("网络错误-09");
                            })
                                .then(function (res) {
                                var _a;
                                loading.value = false;
                                if (res.code === 200) {
                                    // 订单状态 1 创建订单，2 支付完成 3 绑定完成 4 快递中 5 待初检报告 6已完成 7 退款申请 8 退款完成
                                    if (pageParams.pageIndex === 1) {
                                        productsList.value = [];
                                    }
                                    var records = (_a = res.data.records) === null || _a === void 0 ? void 0 : _a.map(function (item) {
                                        var _a;
                                        return __assign(__assign({}, item), { orderPrice: (_a = item.orderPrice) === null || _a === void 0 ? void 0 : _a.toFixed(2) });
                                    });
                                    productsList.value = productsList.value.concat(records);
                                    if (res.data.pages <= pageParams.pageIndex) {
                                        finished.value = true;
                                    }
                                }
                                else {
                                    Toast(res.message);
                                    finished.value = true;
                                }
                            })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var debounceGetOrdersList = debounce(getOrdersList, 300);
        // 支付订单
        var payLoadingVisible = ref(false);
        var handlePayorder = function (orderNo) { return __awaiter(_this, void 0, void 0, function () {
            var res, data, timer_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, payOrder({
                            openId: sessionStorage.getItem("openId"),
                            orderNo: orderNo,
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            data = JSON.parse(res.data);
                            timer_1 = null;
                            wx.chooseWXPay({
                                timestamp: data.timeStamp,
                                nonceStr: data.nonceStr,
                                package: data.package,
                                signType: data.signType,
                                paySign: data.paySign,
                                success: function (res) {
                                    console.log("支付成功" + res);
                                    if (res.errMsg === "chooseWXPay:ok") {
                                        payLoadingVisible.value = true;
                                        timer_1 = setInterval(function () {
                                            checkPaymentResult(orderNo).then(function (res) {
                                                if (res.code === 200) {
                                                    payLoadingVisible.value = false;
                                                    clearInterval(timer_1);
                                                    timer_1 = null;
                                                    pageParams.pageIndex = 0;
                                                    onLoad();
                                                    router.push({
                                                        path: "/payment-success",
                                                        query: {
                                                            orderNo: orderNo,
                                                            skuName: res.data.skuName,
                                                            payTime: res.data.payTime,
                                                            orderPrice: res.data.orderPrice,
                                                        },
                                                    });
                                                }
                                                else {
                                                    Toast(res.message);
                                                }
                                            });
                                        }, 2000);
                                    }
                                },
                                complete: function (res) {
                                    console.log("complete");
                                    console.log(res.errMsg);
                                    console.log(res.errMsg === "chooseWXPay:cancel");
                                    console.log(timer_1);
                                    if (res.errMsg === "chooseWXPay:cancel") {
                                        if (timer_1) {
                                            clearInterval(timer_1);
                                            timer_1 = null;
                                        }
                                    }
                                },
                            });
                        }
                        else {
                            Toast(res.message);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handlePay = function (orderNo) {
            handlePayorder(orderNo);
        };
        // 预览报告
        var reportVisible = ref(false);
        var reportUrl = ref("");
        var handleCancel = function () {
            reportVisible.value = false;
            reportUrl.value = "";
        };
        // 去签字
        var esignVisible = ref(false);
        var esignImgUrl = ref("");
        var loadingVisible = ref(false);
        var orderNo = ref();
        var handleEsign = function (value) {
            orderNo.value = value;
            esignVisible.value = true;
        };
        var handleOk = function (imgUrl) {
            esignImgUrl.value = imgUrl;
            loadingVisible.value = true;
            signName(orderNo.value, esignImgUrl.value)
                .then(function (res) {
                esignVisible.value = false;
                if (res.code === 200) {
                    router.push({
                        path: "/information-binding",
                        query: {
                            orderNo: orderNo.value,
                        },
                    });
                }
                else {
                    Toast(res.message);
                }
            })
                .finally(function () {
                loadingVisible.value = false;
            });
        };
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_tag = _resolveComponent("van-tag");
            var _component_van_col = _resolveComponent("van-col");
            var _component_van_row = _resolveComponent("van-row");
            var _component_van_divider = _resolveComponent("van-divider");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_list = _resolveComponent("van-list");
            var _component_van_loading = _resolveComponent("van-loading");
            var _component_van_overlay = _resolveComponent("van-overlay");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "我的订单",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_van_list, {
                        style: _normalizeStyle({ marginTop: '0.32rem' }),
                        loading: loading.value,
                        "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) { return ((loading).value = $event); }),
                        finished: finished.value,
                        "finished-text": "没有更多了",
                        onLoad: onLoad
                    }, {
                        default: _withCtx(function () { return [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsList.value, function (item) {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "product-item",
                                    key: item.orderNo,
                                    onClick: function ($event) { return (viewDetails(item.orderId, item.orderStatus, item.hasBind)); }
                                }, [
                                    _createElementVNode("div", {
                                        style: _normalizeStyle({ flex: 'auto', padding: '0.32rem' })
                                    }, [
                                        _createElementVNode("p", _hoisted_4, [
                                            _createTextVNode(_toDisplayString(item.skuName) + " ", 1),
                                            (item.orderStatus === 1)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 0,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "warning"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_5
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 2)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 1,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_6
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            ([3, 4, 12].includes(item.orderStatus) && !item.hasBind)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 2,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_7
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            ([3, 4, 5, 11].includes(item.orderStatus) && item.hasBind)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 3,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_8
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 6)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 4,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "success"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_9
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 7)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 5,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_10
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 8)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 6,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "success"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_11
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true),
                                            (item.orderStatus === 10)
                                                ? (_openBlock(), _createBlock(_component_van_tag, {
                                                    key: 7,
                                                    style: _normalizeStyle({ marginLeft: '0.2rem' }),
                                                    type: "danger"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_12
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["style"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createVNode(_component_van_row, { class: "order-field" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_col, {
                                                    class: "order-field-title",
                                                    span: "6"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_13
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_col, { span: "18" }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(item.orderPrice), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ]; }),
                                            _: 2
                                        }, 1024),
                                        _createVNode(_component_van_row, { class: "order-field" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_col, {
                                                    class: "order-field-title",
                                                    span: "6"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_14
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_col, { span: "18" }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(item.testUserName), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ]; }),
                                            _: 2
                                        }, 1024),
                                        _createVNode(_component_van_row, { class: "order-field" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_col, {
                                                    class: "order-field-title",
                                                    span: "6"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_15
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_col, { span: "18" }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(item.sampleCode), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ]; }),
                                            _: 2
                                        }, 1024),
                                        _createVNode(_component_van_row, { class: "order-field" }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(_component_van_col, {
                                                    class: "order-field-title",
                                                    span: "6"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _hoisted_16
                                                    ]; }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_van_col, { span: "18" }, {
                                                    default: _withCtx(function () { return [
                                                        _createTextVNode(_toDisplayString(item.createTimeFormat), 1)
                                                    ]; }),
                                                    _: 2
                                                }, 1024)
                                            ]; }),
                                            _: 2
                                        }, 1024),
                                        ([1, 6].includes(item.orderStatus) ||
                                            ([2, 3, 4, 12].includes(item.orderStatus) && !item.hasBind))
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createVNode(_component_van_divider, { dashed: "" }),
                                                _createElementVNode("div", _hoisted_17, [
                                                    (item.orderStatus === 1)
                                                        ? (_openBlock(), _createBlock(_component_van_button, {
                                                            key: 0,
                                                            round: "",
                                                            color: "#3DABA4",
                                                            plain: "",
                                                            size: "small",
                                                            onClick: _withModifiers(function () { return handlePay(item.orderNo); }, ["stop"])
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_18
                                                            ]; }),
                                                            _: 2
                                                        }, 1032, ["onClick"]))
                                                        : _createCommentVNode("", true),
                                                    (item.orderStatus === 2 && !item.hasBind)
                                                        ? (_openBlock(), _createBlock(_component_van_button, {
                                                            key: 1,
                                                            round: "",
                                                            color: "#3DABA4",
                                                            plain: "",
                                                            size: "small",
                                                            onClick: _withModifiers(function ($event) { return (handleEsign(item.orderNo)); }, ["stop"])
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_19
                                                            ]; }),
                                                            _: 2
                                                        }, 1032, ["onClick"]))
                                                        : _createCommentVNode("", true),
                                                    ([3, 4, 12].includes(item.orderStatus) && !item.hasBind)
                                                        ? (_openBlock(), _createBlock(_component_van_button, {
                                                            key: 2,
                                                            round: "",
                                                            color: "#3DABA4",
                                                            plain: "",
                                                            size: "small",
                                                            onClick: _withModifiers(function ($event) { return (_unref(router).push("information-binding?orderNo=" + item.orderNo)); }, ["stop"])
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_20
                                                            ]; }),
                                                            _: 2
                                                        }, 1032, ["onClick"]))
                                                        : _createCommentVNode("", true),
                                                    (item.orderStatus === 6)
                                                        ? (_openBlock(), _createBlock(_component_van_button, {
                                                            key: 3,
                                                            round: "",
                                                            plain: "",
                                                            size: "small",
                                                            onClick: _withModifiers(function () {
                                                                reportUrl.value = item.reportUrl;
                                                                reportVisible.value = true;
                                                            }, ["stop"])
                                                        }, {
                                                            default: _withCtx(function () { return [
                                                                _hoisted_21
                                                            ]; }),
                                                            _: 2
                                                        }, 1032, ["onClick"]))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ], 4)
                                ], 8, _hoisted_3));
                            }), 128))
                        ]; }),
                        _: 1
                    }, 8, ["style", "loading", "finished"])
                ]),
                _createVNode(_component_van_overlay, {
                    show: payLoadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_23
                                ]; }),
                                _: 1
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"]),
                (reportVisible.value)
                    ? (_openBlock(), _createBlock(ReviewReport, {
                        key: 0,
                        reportUrl: reportUrl.value,
                        onCancel: handleCancel
                    }, null, 8, ["reportUrl"]))
                    : _createCommentVNode("", true),
                (esignVisible.value)
                    ? (_openBlock(), _createBlock(Esign, {
                        key: 1,
                        onCancel: _cache[2] || (_cache[2] = function ($event) { return (esignVisible.value = false); }),
                        onOk: handleOk
                    }))
                    : _createCommentVNode("", true),
                _createVNode(_component_van_overlay, {
                    show: loadingVisible.value,
                    style: { zIndex: 100 }
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_van_loading, {
                                color: "#0094ff",
                                size: "24px",
                                vertical: ""
                            })
                        ])
                    ]; }),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
